import React from 'react';
import { Skeleton, Typography } from '@mui/material';
import FlowResourceDisplay from '../FlowResourceDisplay';
import { FlowModel } from '../../../types/flow.types';
import { EntityDetailCardSection } from '../EntityDetailCard';

interface Props {
  flowModel: FlowModel;
  isLoading?: boolean;
  isSuccess?: boolean;
}

const FlowHeaderDestinationSection: React.FC<Props> = ({
  flowModel,
  isLoading,
}) => (
  <EntityDetailCardSection data-cy="flow-header-destination-section">
    <Typography variant="overline" fontWeight={900}>
      DESTINATION
    </Typography>
    {isLoading ? (
      <Skeleton variant="text" width="100%" />
    ) : (
      <FlowResourceDisplay flow={flowModel} direction="destination" />
    )}
  </EntityDetailCardSection>
);

export default FlowHeaderDestinationSection;
